module.exports = __webpack_public_path__ + "static/img/default-img.1899512.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default-img.png
// module id = 06ro
// module chunks = 5